module.exports = __webpack_public_path__ + "img/why-icon-3.b79f9f3d.svg";